import type { Nullable } from '@web-platform/shared-universal-types-utils/src/utils';
import type { Location } from 'react-router-dom';

export const getVirtualReferrerFromLocationState = (location: Location): Nullable<string> => {
  if (
    location.state != null &&
    Object.prototype.hasOwnProperty.call(location.state, 'virtualReferrer')
  ) {
    const referrer = location.state.virtualReferrer;
    return referrer && referrer.length > 0 ? referrer : null;
  }

  return null;
};
